import React, { useEffect } from 'react'
import { toast } from 'react-toastify'
import jwt_decode from "jwt-decode";
import Loader from '../Layout/Loader'
import { useTranslation } from "react-i18next";
import mainAxios from '../../services/mainAxios';
import Lottie from "lottie-react";
import onlineBank from '../../design/assets/ProfiscLogin.json'
import './Auth.scss'

const ResetEmail = (props) => {
    const { t, i18n } = useTranslation('translations');
    const [state, setState] = React.useState({
        error: null,
        completed: false
    })
    const [loading, setLoading] = React.useState(true);

    useEffect(() => {
        const token = new URLSearchParams(props.location.search).get("t");

        if (!token) {
            toast.error(t(['invite.invalidToken']) || 'Invalid token', {
                containerId: "all_toast"
            });
            setLoading(false);
            setState(state => ({ ...state, error: t('login.invalidToken') }));
            setTimeout(() => props.history.push('/'), 2000);
            return;
        }

        setLoading(true);
        mainAxios.post('general/resetEmail', {
            object: "ResetEmail",
            content: {
                token: token,
            },
        }).then(res => {
            if (res?.data?.status === true) {
                setState(state => ({ ...state, completed: true }));
                toast.success(t(['toast.updateEmail']) || 'Email updated successfully', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    containerId: "all_toast"
                })
                setTimeout(() => props.history.push('/'), 2000);
            } else {
                setState(state => ({
                    ...state,
                    error: res?.data?.message || t('login.failedToUpdateEmail')
                }));
                toast.error(res?.data?.message || t('login.failedToUpdateEmail'), {
                    containerId: "all_toast"
                });
                setTimeout(() => props.history.push('/'), 2000);
            }
            setLoading(false)
        }).catch(err => {
            setState(state => ({
                ...state,
                error: t('login.errorOccurred')
            }));
            toast.error(t('login.errorOccurred'), {
                containerId: "all_toast"
            });
            setLoading(false);
            setTimeout(() => props.history.push('/'), 2000);
        })
    }, [])

    return (
        <div className="auth-page-container">
            <div className="auth-sidebar">
                <div className="sidebar-content">
                    <div className="sidebar-logo">
                        <img src="/Logo-Profisc-2.png" alt="Profisc" />
                    </div>
                    <h2 className="sidebar-title">
                        {t('login.slogan')}
                    </h2>
                </div>
                <Lottie className="sidebar-animation" animationData={onlineBank} loop={false} />
            </div>

            {/* Right Form */}
            <div className="auth-form-wrapper">
                <div className="auth-form-container" style={{ textAlign: 'center' }}>
                    {loading ? (
                        <div style={{ padding: '40px 0' }}>
                            <Loader label={t('common.processing') || 'Processing...'} />
                            <p style={{ marginTop: '20px', color: '#666' }}>
                                {t('login.updatingEmail')}
                            </p>
                        </div>
                    ) : state.error ? (
                        <div>
                            <div style={{ fontSize: '48px', marginBottom: '20px', color: '#dc3545' }}>
                                ✗
                            </div>
                            <h3 className="auth-form-title" style={{ color: '#dc3545' }}>
                                {t('common.error') || 'Error'}
                            </h3>
                            <p className="auth-form-subtitle">
                                {state.error}
                            </p>
                            <p style={{ fontSize: '13px', color: '#999', marginTop: '20px' }}>
                                {t('login.redirectingToLogin')}
                            </p>
                        </div>
                    ) : (
                        <div>
                            <div style={{ fontSize: '48px', marginBottom: '20px', color: '#28a745' }}>
                                ✓
                            </div>
                            <h3 className="auth-form-title" style={{ color: '#28a745' }}>
                                {t('login.emailUpdatedSuccess')}
                            </h3>
                            <p className="auth-form-subtitle">
                                {t('login.emailUpdatedSuccessDesc')}
                            </p>
                            <p style={{ fontSize: '13px', color: '#999', marginTop: '20px' }}>
                                {t('login.redirectingToLogin')}
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default ResetEmail
